// extracted by mini-css-extract-plugin
export default {"dialogFooter":"auditsDialog_dialogFooter__Ah8Yp"};